export default __webpack_public_path__ + "static/image-c-8dba00a5c73ea35fc148af0a7f619659.webp";